import React, { useRef, forwardRef } from 'react';
import { Swiper } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import SwiperPagination from 'components/website/SwiperPagination';

import './overflow-carousel.scss';

const OverflowCarousel = forwardRef(({ children, hasPagination, showDots, showArrows, ...rest }, ref) => {
  const swiperRef = useRef(null);
  return (
    <>
      <div className="overflow-carousel-component">
        <Swiper
          className="swiper mySwiper"
          spaceBetween={16}
          modules={[Pagination, Autoplay]}
          slidesPerView="auto"
          pagination={{
            el: '.swiper-pagination',
            type: 'bullets',
          }}
          ref={ref || swiperRef}
          {...rest}
        >
          {children}

          {hasPagination && <SwiperPagination swiperRef={swiperRef} hasDots={showDots} hasArrows={showArrows} />}
        </Swiper>
      </div>
    </>
  );
});

export default OverflowCarousel;
